import { render, staticRenderFns } from "./studylist.vue?vue&type=template&id=58bee06a&scoped=true&"
import script from "./studylist.vue?vue&type=script&lang=js&"
export * from "./studylist.vue?vue&type=script&lang=js&"
import style0 from "./studylist.vue?vue&type=style&index=0&id=58bee06a&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bee06a",
  null
  
)

export default component.exports